/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Router,
  NavigationEnd,
  RouterLinkActive,
  RouterLink,
} from '@angular/router';
import { DOCUMENT, NgClass } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { AuthService, Role, User } from '@core';
import { RouteInfo } from './sidebar.metadata';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ApplicationConstants } from '@shared/models/constants';
import { HelpersService } from '@shared/services/helpers.service';
import Swal from 'sweetalert2';
import { MatDividerModule } from '@angular/material/divider';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [
    NgScrollbar,
    RouterLinkActive,
    RouterLink,
    NgClass,
    TranslateModule,
    MatDividerModule
  ],
})
export class SidebarComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public sidebarItems!: RouteInfo[];
  public innerHeight?: number;
  public bodyTag!: HTMLElement;
  listMaxHeight?: string;
  listMaxWidth?: string;
  userFullName?: string;
  userRole?: string[];
  filteredRoles?: string[];
  isAdminRole: boolean = false;
  isPrinterRole: boolean = false;
  isOrganizationUserRole: boolean = false;
  isResellerRole: boolean = false;
  capitalizedRoleName?: string;
  userImg?: string;
  userType?: string;
  headerHeight = 60;
  currentRoute?: string;
  isProductReqEnabled: boolean = false;
  item?: RouteInfo;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private helpersService: HelpersService
  ) {
    super();
    this.elementRef.nativeElement.closest('body');
    this.subs.sink = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
    authService.getLogin().subscribe((res) => {
      if (res) {
        this.sortMenuByRoles();
      }
    });
  }
  @HostListener('window:resize', ['$event'])
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  callToggleMenu(event: Event, length: number) {
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');

      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
      } else {
        this.renderer.addClass(parentElement, 'active');
      }
    }
  }
  ngOnInit() {
    if (!this.authService.isLoggedIn) {
      this.router.navigate(['/authentication/signin']);
    }
    this.checkProductEnable();
    if (this.authService.currentUserValue) {
      // const userRole = this.authService.currentUserValue.role;
      this.userRole = this.authService.currentUserValue.role;
      this.displayOnlyNecessaryRoles(this.userRole);
      this.userFullName =
        this.authService.currentUserValue.firstName +
        ' ' +
        this.authService.currentUserValue.lastName;
      this.userImg = this.authService.currentUserValue.img;
      this.sidebarItems = [];
      this.sortMenuByRoles();

      window.addEventListener('storage', (event: StorageEvent) => {
        if (event.key === 'currentUser') {
          const currentUser = event.newValue;
          if (currentUser === null) {
            this.router.navigate(['/authentication/signin']);
          } else {
            // Handle the case when 'currentUser' is not null

            this.sortMenuByRoles();
          }
        }
      });
      // this.sidebarItems = ROUTES.filter(
      //   (x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf('All') !== -1
      // );
      // if (userRole === Role.Admin) {
      //   this.userType = Role.Admin;
      // } else if (userRole === Role.Teacher) {
      //   this.userType = Role.Teacher;
      // } else if (userRole === Role.Student) {
      //   this.userType = Role.Student;
      // } else {
      //   this.userType = Role.Admin;
      // }
    }
    this.applySidebarStateFromStorage();

    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }

  applySidebarStateFromStorage() {
    const isCollapsed = localStorage.getItem('collapsed_menu') === 'true';

    if (isCollapsed) {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }

  get isSidebarCollapsed(): boolean {
  const body = this.document.body;
  const collapsed = localStorage.getItem('collapsed_menu') === 'true';
  const isHovering = body.classList.contains('side-closed-hover');
  return collapsed && !isHovering;
}

  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(firstTime: boolean) {
    if (window.innerWidth < 1025) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  logout() {
    Swal.fire({
      title: 'Logout?',
      text: 'Do you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e0272a',
      cancelButtonColor: '#034EA2',
      confirmButtonText: 'Logout',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        this.subs.sink = this.authService.logout().subscribe((res) => {
          if (!res.success) {

          }
        });
      }
    });
  }

  sortMenuByRoles() {
    if (!this.authService?.currentUserValue) {
      this.router.navigate(['/authentication/signin']);
    }
    this.updateRoute();
    this.sidebarItems = ROUTES;
    var roles = this.getRoles().role;
    if (roles && !roles.includes(ApplicationConstants.ADMIN_ROLE)) {
      this.sidebarItems = ROUTES.filter(
        (x) =>
          x.role.some((r) => roles.indexOf(r) !== -1) ||
          x.role.some((r) => roles.indexOf('All') !== -1)
      );
      var menuList = [];
      for (let index = 0; index < this.sidebarItems.length; index++) {
        var element = this.sidebarItems[index];
        element.submenu = element.submenu.filter(
          (x) =>
            x.role.some((r) => roles.indexOf(r) !== -1) ||
            x.role.some((r) => roles.indexOf('All') !== -1) ||
            x.role.some((r) => roles.indexOf('Admin') !== -1)
        );

        for (let subIndex = 0; subIndex < element.submenu.length; subIndex++) {
          const submenuItem = element.submenu[subIndex];
          if (element.submenu[subIndex].submenu.length > 0) {
            element.submenu[subIndex].submenu = element.submenu[
              subIndex
            ].submenu.filter((x) => {
              var isPSA = roles.includes('PSA') && x.role.includes('PSA');
              return (
                x.role.some((r) => roles.indexOf(r) !== -1) ||
                x.role.some((r) => roles.indexOf('All') !== -1) ||
                x.role.some((r) => roles.indexOf('Admin') !== -1)
              );
            });
          }
        }
        menuList.push(element);
      }
      this.sidebarItems = menuList;
    }
  }

  handleStorageEvent(event: StorageEvent) {
    // Check if the event key is 'currentUser' or 'logout-event'
    if (event.key === 'currentUser') {
      // currentUser has been removed (logged out from another tab)
      this.sortMenuByRoles();
    }
  }

  getRoles(): User {
    return JSON.parse(localStorage.getItem('currentUser') || '{}');
  }


  checkProductEnable() {
    let configDataNew = this.helpersService.getConfigData('IS_PRODUCT_REQUEST_ENABLE', false);
    this.isProductReqEnabled = configDataNew === "true";
  }

  updateRoute() {
    const menuVar = ROUTES.map((item: any) => item.submenu).flat();
    const submenuVar = menuVar.find((submenuItem: any) => submenuItem?.path == 'product-request');

    if (submenuVar) {
      submenuVar.isHide = !this.isProductReqEnabled;
    }
  }

  getSidebarIcon(item: RouteInfo): string {
    const isActive = this.isRouteActive(item, this.router.url);
    if (isActive && item.imgSrc) {
      return item.imgSrc.replace('.svg', '-white.svg');
    }

    return item.imgSrc ?? '';
  }

  private isRouteActive(item: RouteInfo, currentUrl: string): boolean {
    const normalize = (path: string) => path.startsWith('/') ? path : '/' + path;
    const url = normalize(currentUrl);

    const cleanUrl = normalize(currentUrl.split('?')[0]);
    const itemPath = normalize(item.path);

    if (item.submenu && item.submenu.length > 0) {
      return item.submenu.some(sub => this.isRouteActive(sub, currentUrl));
    }

    return cleanUrl === itemPath || cleanUrl.startsWith(itemPath + '/');
  }

  isSubmenuActive(item: RouteInfo): boolean {
    if (!item.submenu || item.submenu.length === 0) {
      return false;
    }

    return item.submenu.some(sub => this.isRouteActive(sub, this.router.url));
  }

  checkUserRoles(role: string): any {    
    switch (role) {
      case ApplicationConstants.ADMIN_ROLE:
        return 'Admin';
      case ApplicationConstants.ORGANIZATION_USER_ROLE:
        return 'Organization User';
      case ApplicationConstants.RESELLER_ROLE:
        return 'Reseller';
      case ApplicationConstants.PRINTER_ROLE:
        return 'Printer'
    }
  }

  displayOnlyNecessaryRoles(userRoles?: string[]){
    this.filteredRoles = userRoles?.filter(item => ApplicationConstants.ALLOWED_ROLES.includes(item));
  }
}



